import { performGetRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';

export const ISSUE_SEARCH_PATH = '/issues/';

// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
export const navigateToIssueSearch = () => window.open(ISSUE_SEARCH_PATH, '_self');

export const navigateToMostRecentProject = () =>
	performGetRequest('/rest/internal/2/productsearch/search?type=projects').then((data) => {
		// @ts-expect-error - TS7031 - Binding element 'id' implicitly has an 'any' type.
		const section = data.find(({ id }) => id === 'quick-search-projects');
		if (section && section.items && section.items[0] && section.items[0].url) {
			// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
			window.open(section.items[0].url, '_self');
		}
	});
